import {
  UpdateReimbursableTaxonomyMappingDocument,
  UpdateReimbursableTaxonomyMappingMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useUpdateReimbursableSupplementMapping = () => {
  const [updateReimbursableSupplementMapping, { loading }] = useMutation(
    UpdateReimbursableTaxonomyMappingDocument,
    {
      extractorFn: (data) => data.payrollMutations.updatePayrollReimbursableSupplementTaxonomy,
    }
  )

  return {
    loading,
    update(variables: UpdateReimbursableTaxonomyMappingMutationVariables) {
      return updateReimbursableSupplementMapping({
        variables,
      })
    },
  }
}

export default useUpdateReimbursableSupplementMapping
